<template>
    <div v-if="showFeature">
        <slot :id="`feature-${featureKey}-${subKey}`"/>
    </div>
    <router-link :to="{ name: 'settings.company' }" v-else-if="messageIfNoAccess">
       <p v-html="messageVal"></p>
    </router-link>
</template>

<script>
import Feature from "../models/Feature";
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";
import {useRepo} from "pinia-orm";

export default {
    props: {
        featureKey: String,
        subKey: String,
        messageIfNoAccess: Boolean,
        message: String,
    },
    data: function () {
        return {
            messageVal: null
        }
    },
    computed: {
        ...mapStores(useMainStore),
        showFeature() {
            // If feature is not known to the database we'll not show it
            if (!this.feature)
                return false;

            // Else we'll check if the company has access to it.
            return this.mainStore.currentCompany.feature_ids.includes(this.feature.id);
        },
        feature() {
            return useRepo(Feature).where('key', this.featureKey).first();
       }
    },
    mounted() {
        this.messageVal = this.message ?? this.$t('features.no_access');
    }
}
</script>
